import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService, MenuItem } from "primeng/api";
import { CategoryService } from "../../../services/categories.service";
import { Category } from "../../../models/category";
import { MessageService } from "primeng/api";
import { ComuniService } from "src/app/services/comuni.service";
import { Comuni } from "src/app/models/comuni";
// jspdf removed - add back if PDF export needed
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import { NgxSpinnerService } from "ngx-spinner";
import {
  PARAM_CLIENTS_PATH,
  PARAM_EMPLOYEES_PATH,
  PARAM_NEWS_PATH,
  PARAM_PAGES_PATH,
} from "../../constants/constants";
import { NewsService } from "src/app/services/news.service";
import { News } from "src/app/models/news";
import { PagesService } from "src/app/services/pages.service";
import { Pages } from "src/app/models/pages";

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DrawerModule } from "primeng/drawer";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";
import { TagModule } from "primeng/tag";

import { TopNavComponent } from "src/app/top-nav/top-nav.component";

import { NgxPaginationModule } from "ngx-pagination";

@Component({
  standalone: true,
  selector: "app-manage-pages",
  templateUrl: "./manage-pages.component.html",
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    DialogModule,
    DrawerModule,
    SelectModule,
    TooltipModule,
    TagModule, TopNavComponent, NgxPaginationModule,],
})
export class ManagePagesComponent implements OnInit {
  pagess: any = [];
  pages: Pages;

  filterSidebar: boolean;
  error: string;
  cols: any[];
  exportColumns: any[];
  _selectedColumns: any[];
  currentUser: any;
  page = 1;
  count = 0;
  pageSize = 10;
  pageSizes = [5, 10, 15];
  nameFilter: string;
  descriptionFilter: string;
  codeFilter: string;
  codeIntFilter: string;
  brandFilter: string;

  productDialog: boolean = false;

  showDialog() {
    this.productDialog = true;
  }

  trackByFn(index, item) {
    return item.id;
  }

  constructor(
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private pagesService: PagesService,
    private categoryService: CategoryService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
    const userId = this.currentUser.user_id;

    this.spinner.show();
    this.load();

    this.cols = [
      { field: "page_title", header: "Titolo" },
      { field: "page_url", header: "Seo URL" },
      { field: "subpages", header: "Seo URL" },
    ];

    this._selectedColumns = this.cols;
    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));
    this.spinner.hide();
  }

  getRequestParams(searchTitle, categoryTitle, page, pageSize): any {
    // tslint:disable-next-line:prefer-const
    let path = PARAM_PAGES_PATH;
    const params = {};
    let adder = "?";
    if (page) {
      params[`page`] = page - 1;
      path += adder + "page=" + (page - 1);
      adder = "&";
    }
    if (searchTitle) {
      params[`name`] = searchTitle;
      path += adder + "name=" + searchTitle;
      adder = "&";
    }
    if (categoryTitle) {
      params[`description`] = categoryTitle;
      path += adder + "description=" + categoryTitle;
      adder = "&";
    }

    if (pageSize) {
      params[`size`] = pageSize;
      path += adder + "size=" + pageSize;
    }
    window.history.replaceState({}, "", path);

    return params;
  }

  reset(): void {
    this.nameFilter = "";
    this.descriptionFilter = "";
    this.codeFilter = "";
    this.codeIntFilter = "";
    this.brandFilter = "";
    this.load();
  }

  load(): void {
    const params = this.getRequestParams(
      this.nameFilter,
      this.descriptionFilter,
      this.page,
      (this.pageSize = 100),
    );
    this.pagesService.list(params).subscribe((pData) => {
      this.pagess = pData;
      this.count = this.pagesService.size;
    });
  }

  public handlePageChange(event): void {
    this.page = event;
    this.load();
  }

  public selectionItemForFilter(e) {
    const colsTempor = e.value;
    colsTempor.sort(function (a, b) {
      return a.index - b.index;
    });
    this.cols = [];
    this.cols = colsTempor;
    if (e.value.length > 10) {
      e.value.pop();
    }
  }

  edit(pages: Pages) {
    this.pages = { ...pages };
    this.productDialog = true;
  }

  hideDialog() {
    this.productDialog = false;
  }

  onDelete(id: number, title: string) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.pagesService.delete(+id).subscribe(
          (res) => {
            console.log(res);
            this.ngOnInit();
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Cancellazione avvenuto con successo",
            });
          },
          (error) => {
            this.error = error;
            this.messageService.add({
              key: "myKey2",
              severity: "warn",
              summary: "Attenzione",
              detail: "Errore backend",
            });
          },
        );
      },
    });
  }
}
